
/* Framivo: accept af forudbetaling / ingen fortrydelsesret før kassen (samme som på /cart). */
function ACCEPT_HTML(){
  var lang=(document.documentElement.lang||'da').toLowerCase().slice(0,2);
  var T={
    da:['Jeg accepterer <a href="/policies/legal-notice" target="_blank" style="text-decoration:underline">handelsbetingelserne</a> og er indforstået med, at mine varer – også i standardmål – fremstilles efter min bestilling, at beløbet trækkes ved bestillingen, og at der derfor ikke er fortrydelsesret.','Sæt kryds for at acceptere betingelserne, før du går til kassen.'],
    sv:['Jag godkänner <a href="/policies/legal-notice" target="_blank" style="text-decoration:underline">köpvillkoren</a> och är införstådd med att mina varor – även i standardmått – tillverkas efter min beställning, att beloppet dras vid beställningen och att det därför inte finns någon ångerrätt.','Kryssa i rutan för att godkänna villkoren innan du går till kassan.'],
    nb:['Jeg godtar <a href="/policies/legal-notice" target="_blank" style="text-decoration:underline">kjøpsvilkårene</a> og er innforstått med at varene mine – også i standardmål – produseres etter min bestilling, at beløpet trekkes ved bestillingen, og at det derfor ikke er angrerett.','Kryss av i boksen for å godta vilkårene før du går til kassen.'],
    en:['I accept the <a href="/policies/legal-notice" target="_blank" style="text-decoration:underline">terms and conditions</a> and understand that my items – including standard sizes – are made to order, that payment is taken when I place the order, and that there is therefore no right of withdrawal.','Please tick the box to accept the terms before checking out.']
  };
  if(lang==='no'||lang==='nn') lang='nb';
  var t=T[lang]||T.en;
  var base=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var txt=t[0].replace('href="/policies/','href="'+base+'policies/');
  return '<label style="display:flex;gap:8px;align-items:flex-start;margin:10px 0 6px;font-size:13px;line-height:1.4;text-align:left"><input type="checkbox" id="cd-accept" style="margin-top:2px;flex:none;width:16px;height:16px"><span>'+txt+'</span></label><div id="cd-accept-msg" style="display:none;color:#b00020;font-size:12px;margin:0 0 6px">'+t[1]+'</div>';
}
document.addEventListener('click',function(e){
  var a=e.target.closest&&e.target.closest('.cd-checkout'); if(!a) return;
  var cb=document.getElementById('cd-accept');
  if(cb && !cb.checked){ e.preventDefault(); var m=document.getElementById('cd-accept-msg'); if(m) m.style.display='block'; cb.focus(); }
});
document.addEventListener('change',function(e){ if(e.target&&e.target.id==='cd-accept'&&e.target.checked){ var m=document.getElementById('cd-accept-msg'); if(m) m.style.display='none'; } });

/* maaho-header.js - mobile nav toggle and the cart drawer (open/close, render
   cart contents, and the global add-to-cart interception). */

(function () {
  var mn = document.getElementById('mNav');

  document.querySelectorAll('[data-mopen]').forEach(function (b) {
    b.onclick = function () { mn.classList.add('open'); };
  });

  if (mn) {
    mn.querySelectorAll('[data-mclose]').forEach(function (e) {
      e.onclick = function () { mn.classList.remove('open'); };
    });
    mn.querySelectorAll('[data-acc]').forEach(function (b) {
      b.onclick = function () { this.parentNode.classList.toggle('open'); };
    });
  }

  var d = document.getElementById('cartDrawer');
  if (!d) return;

  function op() { d.classList.add('open'); }
  function cl() { d.classList.remove('open'); }

  // The cart's own currency and the page's locale, not a hardcoded 'kr': maaho.fr prices
  // in EUR, maaho.se in SEK, and the drawer used to print kroner on all of them.
  // <html lang> is set from request.locale.iso_code in layout/theme.liquid.
  function formatter(currency) {
    var locale = document.documentElement.lang || 'da';
    try {
      var nf = new Intl.NumberFormat(locale, { style: 'currency', currency: currency });
      return function (cents) { return nf.format(cents / 100); };
    } catch (e) {
      // An unknown currency code would otherwise throw and take the whole drawer down.
      return function (cents) {
        return (cents / 100).toLocaleString(locale, { minimumFractionDigits: 2 }) +
          ' ' + currency;
      };
    }
  }

  // Discount titles are merchant-written and go into innerHTML.
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  function labels() {
    return {
      subtotal: d.dataset.labelSubtotal || 'Subtotal',
      discount: d.dataset.labelDiscount || 'Discount',
      total: d.dataset.labelTotal || 'Total',
      empty: d.dataset.labelEmpty || 'Your cart is empty',
      checkout: d.dataset.labelCheckout || 'Check out',
      viewcart: d.dataset.labelViewcart || 'View cart',
      remove: d.dataset.labelRemove || 'Remove'
    };
  }

  /* The remove control: a bin, drawn inline so nothing is fetched. currentColor lets the
     button's own colour and hover state paint it. */
  var BIN_ICON =
    "<svg viewBox='0 0 24 24' width='16' height='16' fill='none' stroke='currentColor'" +
    " stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round' aria-hidden='true'>" +
    "<path d='M3 6h18'/><path d='M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2'/>" +
    "<path d='M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6'/>" +
    "<path d='M10 11v6'/><path d='M14 11v6'/></svg>";

  // Subtotal before discounts, then each discount, then what is actually payable. The
  // drawer used to label total_price "Subtotal", so a discounted cart showed a figure
  // lower than the sum of its lines with nothing to explain it.
  function totals(c) {
    var money = formatter(c.currency);
    var l = labels();
    var rows = `<div class='cd-sub'><span>${l.subtotal}</span><span>${money(c.items_subtotal_price)}</span></div>`;

    (c.cart_level_discount_applications || []).forEach(function (a) {
      // The label is translated; the name is whatever the merchant called the discount in
      // Shopify, which is never translated - "Ældresagen" means nothing to a French buyer,
      // so it is shown as a quiet aside to the word they do understand.
      var named = a.title ? ` <span class='cd-sub-name'>${esc(a.title)}</span>` : '';
      rows += `<div class='cd-sub cd-sub-discount'><span>${l.discount}${named}</span><span>−${money(a.total_allocated_amount)}</span></div>`;
    });

    if (c.total_discount) {
      rows += `<div class='cd-sub cd-sub-total'><span>${l.total}</span><span>${money(c.total_price)}</span></div>`;
    }
    return rows;
  }

  function ph(p) {
    if (!p) return '';
    return Object.keys(p)
      .filter(function (k) { return k.charAt(0) !== '_' && p[k]; })
      .map(function (k) { return `<span>${k}: ${p[k]}</span>`; })
      .join('');
  }

  function vname(it) {
    var v = it.variant_title;
    if (v && v !== 'Default Title') return v;
    var o = it.variant_options;
    if (o && o.length && o[0] && o[0] !== 'Default Title') return o.join(' / ');
    return '';
  }

  function rnd(c) {
    var b = document.getElementById('cdBody'), f = document.getElementById('cdFoot');
    var l = labels();
    if (!c.items || !c.items.length) {
      b.innerHTML = `<p class='cd-empty'>${l.empty}</p>`;
      f.innerHTML = '';
    } else {
      var mo = formatter(c.currency);
      b.innerHTML = c.items.map(function (it) {
        var v = vname(it);
        var vt = v ? `<div class='cd-i-variant'>${v}</div>` : '';
        return `<div class='cd-item'><img src='${it.image || ''}' alt=''><div><div class='cd-i-title'>${it.product_title}</div>${vt}<div class='cd-i-props'>${ph(it.properties)}</div><div class='cd-i-meta'><span>${it.quantity} × ${mo(it.final_price)}</span><button class='cd-rm' data-k='${it.key}' aria-label='${esc(l.remove)}' title='${esc(l.remove)}'>${BIN_ICON}</button></div></div></div>`;
      }).join('');
      f.innerHTML = totals(c) + ACCEPT_HTML() + `<a class='btn cd-checkout' href='/checkout'>${l.checkout}</a><a class='cd-viewcart' href='/cart'>${l.viewcart}</a>`;
    }
    document.querySelectorAll('.cart-count').forEach(function (e) { e.textContent = c.item_count; });
  }

  /*
    The cart carries its shop's country as the _maaho_market attribute, because the
    checkout cannot know which domain filled it - choosing a delivery country switches
    the whole checkout to that market. The vat-country-validation function compares the
    delivery country against this stamp and blocks a mismatch. Fire-and-forget, and an
    unstamped cart is allowed, never blocked - a missing stamp must not cost a sale.
  */
  function stamp(c) {
    var marketCountry = d.dataset.marketCountry || '';
    if (!marketCountry || !c.items || !c.items.length) return;
    if ((c.attributes || {})._maaho_market === marketCountry) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { _maaho_market: marketCountry } })
    }).catch(function () {});
  }

  function rf() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { stamp(c); return rnd(c); });
  }

  d.querySelectorAll('[data-close]').forEach(function (e) { e.onclick = cl; });

  document.querySelectorAll('.js-cart').forEach(function (a) {
    a.onclick = function (e) {
      e.preventDefault();
      rf().then(op);
    };
  });

  document.addEventListener('maaho:cartadd', function () {
    rf().then(op);
  });

  // A truly disabled Add to cart button fires no submit event at all, so a
  // product page that needs to block one calls event.preventDefault() itself
  // and this respects that instead of adding to the cart anyway.
  document.addEventListener('submit', function (e) {
    if (e.defaultPrevented) return;
    var f = e.target;
    if (f && f.getAttribute && f.getAttribute('action') && f.getAttribute('action').indexOf('/cart/add') > -1) {
      e.preventDefault();
      fetch('/cart/add.js', { method: 'POST', body: new FormData(f) })
        .then(function (r) { return r.json(); })
        .then(function () { return rf(); })
        .then(op)
        .catch(function () { f.submit(); });
    }
  });

  d.addEventListener('click', function (e) {
    // closest, not the target itself: a click can land on the icon inside the button.
    var t = e.target.closest ? e.target.closest('.cd-rm') : null;
    if (t) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: t.getAttribute('data-k'), quantity: 0 })
      }).then(function (r) { return r.json(); }).then(rnd);
    }
  });
})();
